<template>
    <div class="hero-video">
        <!-- 视频背景 -->
        <video autoplay loop muted playsinline class="background-video" :src="videoSrc"
            poster="https://www.xael-ai.net/mmexport1774234867510.mp4"></video>
        <div class="overlay"></div>

        <div class="hero-content" data-aos="fade-up">
            <h1>
                <span id="typed-main">{{ typedText }}</span>
                <!-- <span class="typed-cursor typed-cursor--blink" aria-hidden="true">▌</span> -->
            </h1>
            <div class="subtitle">
                A global platform leading the new era of embodied intelligence
            </div>
            <router-link to="/company/index" class="cta-button">Learn More <i
                    class="fas fa-chevron-right"></i></router-link>
        </div>
    </div>
</template>

<script>
import Typed from 'typed.js';

export default {
    name: 'HeroCarousel',
    data() {
        return {
            videoSrc: 'https://www.xael-ai.net/mmexport1774234867510.mp4', // 
            typedText: 'Future', // 初始文本，Typed 会动态替换
        };
    },
    mounted() {
        // 如果已有实例则先销毁
        if (this.typedInstance) {
            this.typedInstance.destroy();
        }
        // 初始化 Typed.js 实现打字效果
        new Typed('#typed-main', {
            strings: ['Future', 'SXVE-Al', 'Growth'], // 可配置多个词循环
            typeSpeed: 60,
            backSpeed: 40,
            backDelay: 1500,
            startDelay: 500,
            loop: true,
            showCursor: true, // 因为我们已经有独立的光标元素，所以隐藏 Typed 自带光标
        });
    },
    beforeDestroy() {
        // 组件销毁前必须销毁 Typed 实例
        if (this.typedInstance) {
            this.typedInstance.destroy();
        }
    },
};
</script>

<style scoped>
.hero-video {
    position: relative;
    height: 100vh;
    min-height: 600px;
    width: 100%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
}

.background-video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0;
}

.overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.2);
    z-index: 1;
}

.hero-content {
    position: relative;
    z-index: 2;
    text-align: center;
    color: white;
    max-width: 800px;
    padding: 0 20px;
}

.hero-content h1 {
    font-size: 4rem;
    font-weight: 700;
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
}

#typed-main {
    display: inline-block;
}

.typed-cursor {
    font-size: 4rem;
    font-weight: 300;
    color: white;
    animation: blink 1s step-end infinite;
}

@keyframes blink {

    from,
    to {
        opacity: 1;
    }

    50% {
        opacity: 0;
    }
}

.subtitle {
    font-size: 1.25rem;
    margin-bottom: 30px;
    line-height: 1.6;
    opacity: 0.95;
}

.cta-button {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background-color: transparent;
    border: 2px solid white;
    color: white;
    padding: 12px 28px;
    border-radius: 40px;
    font-weight: 600;
    font-size: 1rem;
    text-decoration: none;
    transition: background 0.2s, transform 0.2s;
}

.cta-button:hover {
    background-color: #0050b3;
    transform: scale(1.02);
}

.cta-button i {
    font-size: 0.9rem;
    transition: transform 0.2s;
}

.cta-button:hover i {
    transform: translateX(4px);
}

/* 响应式 */
@media (max-width: 768px) {
    .hero-content h1 {
        font-size: 2.5rem;
    }

    .typed-cursor {
        font-size: 2.5rem;
    }

    .subtitle {
        font-size: 1rem;
    }
}
</style>